import { IPriceListPanelProps, ICommonListProps } from '../types';

export const getCommonListProps = (
  props: IPriceListPanelProps
): ICommonListProps => {
  return {
    productId: props.productId,
    productName: props.productName,
    media: props.media,
    brand: props.brand,
    campaign: props.campaign,
  };
};
